import React from 'react';
import PropTypes from 'prop-types';
import { Subtitle2 } from 'components/Typography';
import SwipeListPanel from '../SwipeListPanel';
import filterTypes from '../SwipeListPanel/filterTypes';

const EmptyStateMessage = (swipeRetentionTime) =>
    `There have been no competencies awarded in the past ${swipeRetentionTime} hours`;

class CompetencySwipeList extends React.Component {

    header = () => (<Subtitle2>Competencies</Subtitle2>);

    render() {
        return (
            <SwipeListPanel
                HeaderComponent={this.header}
                emptyStateMessage={EmptyStateMessage}
                showEmptyFilterMessage={false}
                swipes={this.props.swipes}
                config={this.props.config}
                location={this.props.location}
                supervisorData={this.props.supervisorData}
                currentFilter={filterTypes.Competencies} />
        );
    }
}

CompetencySwipeList.propTypes = {
    swipes: PropTypes.arrayOf(PropTypes.object).isRequired,
    config: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    supervisorData: PropTypes.object.isRequired
};

export default CompetencySwipeList;